import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../../context/ToastContext";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { useTheme } from "../../../context/ThemeContext";

export const useEvaluateList = () => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const { theme } = useTheme();
    const tagRef = useRef(null);
    const selectedRowRef = useRef([]);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const [showPopup, setShowPopup] = useState(false);
    const [formValue, setFormValue] = useState({});
    const [filterValue, setFilterValue] = useState({ additional_filters: { label: "Reporting", key: "reporting", icon: "network-wired", count_key: "reporting_count" }, additional_filters_counts: {} });
    const [selectedRow, setSelectedRow] = useState([]);
    const [exclude, setExclude] = useState({ visible: false, users: [], view: false });
    const [options, setOptions] = useState({
        survey_list: [],
        users: [],
        evaluator_status: [],
        units: [],
        all_users: [],
        filtered_exclude_users: [],
        group_by: [{ label: "Group By Employee", value: true }, { label: "Group By Evaluator", value: false }],
        additional_filters: [
            {
                label: "Reporting",
                key: "reporting",
                icon: "network-wired",
                count_key: "reporting_count"
            },
            {
                label: "Project Team",
                key: "project_team",
                icon: "suitcase",
                count_key: "project_team_count"
            },
            {
                label: "Communicators",
                key: "project_communicators",
                icon: "message",
                count_key: "project_comm_count"
            },
            {
                label: "Hierarchy",
                key: "hierarchy",
                icon: "user-group",
                count_key: "hierarchy_count"
            },
            {
                label: "Manual",
                key: "manual",
                icon: "circle-plus",
                count_key: "manual_map_count"
            },
            {
                label: "Client",
                key: "client_lead_map",
                icon: "user-group",
                count_key: "client_lead_map_count"
            },
        ]
    })
    const colDef = [
        {
            key: "checkbox",
            label: "",
            checkbox: true,
            style: { width: "3%" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                const checked = row?.id === "all" ? (_.isEmpty(rowData) ? false : _.every(_.pluck(rowData, "children")?.flatMap(item => item), item => _.pluck(selectedRow, "index")?.includes(item?.index))) : !_.isEmpty(_.findWhere(selectedRow, { index: row?.index }));

                const handleTaskSelection = (row, e) => {
                    let val = [...selectedRow];
                    if (row?.id === "all") {
                        val = e.target?.checked ? [..._.pluck(rowData, "children")?.flatMap(item => item)] : []
                    } else {
                        val = e.target?.checked ? [...selectedRowRef.current, row] : _.filter(selectedRow, item => item?.index !== row?.index);
                    }
                    selectedRowRef.current = _.uniq(val, "index");
                    setSelectedRow(_.uniq(val, "index"));
                }
                return (
                    <div className="d-flex justify-content-center w100">
                        <input type="checkbox" className="input-dd" checked={checked} onChange={(e) => handleTaskSelection(row, e)} />
                    </div>
                );
            },

        },
        {
            key: "user_display_name",
            label: "Subject Name",
            style: { width: "15%" },
            headerStyle: { textAlign: "left" },
            hide: filterValue?.group_by !== undefined,
            render: (rowdata) => {
                const tooltip = rowdata?.user_display_name + " (" + rowdata?.user_employee_id + ")";
                return (
                    <div className="py-1 d-flex gap-2 align-items-center">
                        <img className="rounded-circle" src={rowdata?.user_image_url} width={25} height={25} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                        <div className="fw-semibold text-truncate w90" title={tooltip}>{rowdata?.user_display_name} <span style={{ fontSize: "0.7rem", fontWeight: "normal" }}>({rowdata?.user_employee_id})</span></div>
                    </div>
                )
            }
        },
        {
            key: "user_project_name",
            label: "Subject Primary Project",
            style: { width: "10%", fontWeight: 600 },
            hide: filterValue?.group_by !== undefined,
            render: (rowdata) => {
                return (
                    <div className="text-truncate" title={rowdata?.user_project_name}>{rowdata?.user_project_name}</div>
                )
            }
        },
        {
            key: "user_role_on_project",
            label: "Subject Role on Project",
            style: { width: "10%" },
            hide: filterValue?.group_by !== undefined,
            render: (rowdata) => {
                return (
                    <div className="text-truncate" title={rowdata?.user_role_on_project}>{rowdata?.user_role_on_project}</div>
                )
            }
        },
        {
            key: "user_technology",
            label: "Subject Technology",
            style: { width: "10%" },
            hide: filterValue?.group_by !== undefined,
            render: (rowdata) => {
                return (
                    <div className="text-truncate" title={rowdata?.user_technology}>{rowdata?.user_technology}</div>
                )
            }
        },
        {
            key: (filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_display_name" : "user_display_name",
            label: (filterValue?.group_by === undefined || filterValue?.group_by === true) ? "Evaluator Name" : "Employee Name",
            style: { width: filterValue?.group_by === undefined ? "10%" : "25%" },
            headerStyle: { textAlign: "left" },
            render: (rowdata) => {
                const tooltip = rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_display_name" : "user_display_name"] + " (" + rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_employee_id" : "user_employee_id"] + ")";
                return (
                    <div className="py-1 d-flex gap-2 align-items-center">
                        <img className="rounded-circle" src={rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_image_url" : "user_image_url"]} width={25} height={25} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                        <div className="fw-semibold text-truncate w90" title={tooltip}>
                            {rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_display_name" : "user_display_name"]}&nbsp;
                            <span style={{ fontSize: "0.7rem", fontWeight: "normal" }}>({rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_employee_id" : "user_employee_id"]})</span>
                        </div>
                    </div>
                )
            }
        },
        {
            key: (filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_project_name" : "user_project_name",
            label: filterValue?.group_by === undefined ? "Evaluator Primary Project" : "Primary Project",
            style: { width: filterValue?.group_by === undefined ? "10%" : "15%", fontWeight: 600 },
            render: (rowdata) => {
                const value = rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_project_name" : "user_project_name"];
                return (
                    <div className="text-truncate" title={value}>{value}</div>
                )
            }
        },
        {
            key: (filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_role_on_project" : "user_role_on_project",
            label: filterValue?.group_by === undefined ? "Evaluator Role on Project" : "Role on Project",
            style: { width: filterValue?.group_by === undefined ? "10%" : "25%" },
            render: (rowdata) => {
                const value = rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_role_on_project" : "user_role_on_project"];
                return (
                    <div className="text-truncate" title={value}>{value}</div>
                )
            }
        },
        {
            key: (filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_technology" : "user_technology",
            label: filterValue?.group_by === undefined ? "Evaluator Technology" : "Technology",
            style: { width: filterValue?.group_by === undefined ? "10%" : "15%" },
            render: (rowdata) => {
                const value = rowdata?.[(filterValue?.group_by === undefined || filterValue?.group_by === true) ? "evaluator_technology" : "user_technology"];
                return (
                    <div className="text-truncate" title={value}>{value}</div>
                )
            }
        },
        {
            key: "status",
            label: "Status",
            style: { width: filterValue?.group_by === undefined ? "7%" : "10%" },
            headerStyle: { textAlign: "center" },
            render: (rowdata) => {
                let obj = { bg: theme === "dark" ? "#444444" : "#fafafa", color: "grey", border: "#d4d4d4" };
                if (!rowdata?.is_verified && !rowdata?.is_discard) {
                    obj = { bg: theme === "dark" ? "#585349" : "#fff6e7", color: "#f59e0b", border: "#f8d79f" };
                } else if (rowdata?.is_survey_sent) {
                    obj = {
                        bg: theme === "dark" ? "#1e293b" : "#e0f2fe", color: "#0284c7", border: "#bae6fd"
                    };
                } else if (rowdata?.is_verified) {
                    obj = { bg: theme === "dark" ? "#2e3a2e" : "#d6edd6", color: "green", border: "#b2cfb2" };
                }
                return (
                    <div className="d-flex justify-content-center">
                        <span className="rounded-pill px-2 fw-semibold text-uppercase" style={{ backgroundColor: obj?.bg, color: obj?.color, border: `1px solid ${obj?.border}`, fontSize: "0.7rem" }}>{rowdata?.status}</span>
                    </div>
                )
            }
        },
        {
            key: "action",
            label: "Action",
            style: { width: filterValue?.group_by === undefined ? "5%" : "7%" },
            headerStyle: { textAlign: "center" },
            render: (rowdata) => {
                return (
                    <div className='d-flex gap-1 justify-content-center'>
                        <button className={`sk-btn sk-btn-primary ${rowdata?.is_verified ? "invisible" : "visible"}`} title='Verify Selected Mapping' onClick={() => saveAction(rowdata, true)}><FontAwesomeIcon icon={faCircleCheck} /></button>
                        <button className={`sk-btn sk-btn-danger ${rowdata?.is_discard ? "invisible" : "visible"}`} title='Mark Selected as Irrelevant' onClick={() => saveAction(rowdata, false)}><FontAwesomeIcon icon={faCircleXmark} /></button>
                    </div>
                )
            }
        },
    ]

    useEffect(() => {
        sessionStorage.removeItem("survey_details");
        callautopopulate("evaluator_users", "survey_details", "evaluator_status", "users", "day_calendar_groups", "projects", "project_leads").then(async res => {
            const leads = res?.project_leads?.map(item => { return { ...item, group_id: _.findWhere(res?.users, { user_code: item?.user_code })?.group_id } })
            setOptions((prev) => ({
                ...prev, survey_list: _.filter(_.sortBy(res?.survey_details, "survey_status"), { survey_status: "active" }),
                users: _.sortBy(_.uniq(res?.evaluator_users, (item) => item.evaluator_user_code), "evaluator_user_name"),
                evaluator_status: res?.evaluator_status, all_users: _.sortBy(res?.users, "user_display_name"),
                units: _.sortBy(res?.day_calendar_groups, "group_name"),
                projects: _.sortBy(res?.projects, "project_name"),
                leads: _.sortBy(leads, "user_display_name"),
                filtered_leads: _.sortBy(leads, "user_display_name")
            }));
        })
    }, [])


    useEffect(() => {
        if (!_.isEmpty(filterValue?.unit)) {
            const filtered_leads = _.filter(options?.leads, item => _.pluck(filterValue?.unit, "group_id")?.includes(item?.group_id));
            setOptions((prev) => ({ ...prev, filtered_leads }))
            setFilterValue((prev) => ({ ...prev, "lead": _.filter(filterValue?.lead, item => filtered_leads?.includes(item)) }))
        } else {
            setOptions((prev) => ({ ...prev, filtered_leads: options?.leads }));
        }
    }, [filterValue?.unit])




    useEffect(() => {
        setOptions((prev) => ({ ...prev, filtered_exclude_users: exclude?.view ? [..._.sortBy(exclude?.api_data, "user_display_name")] : [..._.filter(options?.all_users, item => !exclude?.api_data?.includes(item))] }));
    }, [exclude?.view, options?.all_users, exclude?.api_data])

    useEffect(() => {
        getEvaluatorList();
    }, [filterValue?.additional_filters, theme])

    const getEvaluatorList = async (key) => {
        try {
            if (!filterValue?.survey?.survey_id) return;
            setLoader((prev) => ({ ...prev, grid: true }));
            let grouping = key === "group" ? undefined : filterValue?.group_by;
            const payload = {
                "survey_id": filterValue?.survey?.survey_id || 0,
                "employee_user_code": _.pluck(filterValue?.users, "evaluator_user_code")?.toString() || "",
                "evaluator_user_code": _.pluck(filterValue?.evaluator, "evaluator_user_code")?.toString() || "",
                "status_key": (key === "status" ? "" : filterValue?.status?.status_key) || "",
                "unit_ids": _.pluck(filterValue?.unit, "group_id")?.toString() || "",
                "survey_view_type": filterValue?.additional_filters?.key || "",
                "project_ids": filterValue?.projects?.toString() || "",
                "lead_user_codes": key === "leads" ? "" : filterValue?.leads?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSEREVALUATORMAPPINGLIST"), payload)
            if (!res?.body?.error_status) {
                const data = _.uniq(res?.body?.data?.survey_user_evaluator_mapping_list, item => `${item?.user_display_name}-${item?.evaluator_display_name}`)?.map((item, index) => { return { ...item, index, status: !item?.is_verified && !item?.is_discard ? "pending" : item?.is_survey_sent ? "Sent" : item?.is_verified ? "verified" : "irrelevant" } });
                let groupedRowData = [];
                if (grouping !== undefined) {
                    data?.forEach(user => {
                        if (_.isEmpty(_.findWhere(groupedRowData, { id: user?.[grouping ? "user_display_name" : "evaluator_display_name"] }))) {
                            const obj = {
                                ...user,
                                id: user?.[grouping ? "user_display_name" : "evaluator_display_name"],
                                title: user?.[grouping ? "user_display_name" : "evaluator_display_name"],
                                children: _.sortBy(_.filter(data, item => item?.[grouping ? "user_display_name" : "evaluator_display_name"] === user?.[grouping ? "user_display_name" : "evaluator_display_name"]), grouping ? "evaluator_display_name" : "user_display_name"),
                                titleTemplate: (groupdata) => {
                                    const checked = _.every(_.pluck(groupdata?.children, "index"), item => _.pluck(selectedRowRef?.current, "index")?.includes(item)) || false;
                                    const handleSelection = (checked, data) => {
                                        let selected = [...selectedRowRef?.current];
                                        if (checked) {
                                            selected = selected.concat(data);
                                        } else {
                                            selected = _.filter(selected, item => !_.pluck(data, "index")?.includes(item?.index));
                                        }
                                        setSelectedRow(_.uniq(selected, "index"));
                                        selectedRowRef.current = _.uniq(selected, "index");
                                    }

                                    const pendingCount = _.filter(groupdata?.children, item => (!item?.is_verified && !item?.is_discard))?.length;
                                    const verifiedCount = _.filter(groupdata?.children, item => item?.is_verified)?.length;
                                    const irrelevantCount = _.filter(groupdata?.children, item => item?.is_discard)?.length;
                                    return (
                                        <div className="ms-2 d-flex gap-3 align-items-center py-1 px-2">
                                            <input type="checkbox" checked={checked} onClick={(e) => e?.stopPropagation()} onChange={(e) => { handleSelection(e.target?.checked, groupdata?.children) }} />
                                            <img className="rounded-circle" src={groupdata?.[grouping ? "user_image_url" : "evaluator_image_url"]} width={25} height={25} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                                            <div className="fw-bold" > {groupdata?.title} ({groupdata?.[grouping ? "user_employee_id" : "evaluator_employee_id"]})</div>
                                            <div className="border p-1" style={{ backgroundColor: theme === "dark" ? "#3f3f3f" : "white" }}>{groupdata?.children?.length} mappings</div>
                                            {pendingCount > 0 && <div style={{ color: "#f59e0b" }}>{pendingCount} pending</div>}
                                            {verifiedCount > 0 && <div className="text-success">{verifiedCount} verified</div>}
                                            {irrelevantCount > 0 && <div style={{ color: "#9e9e9e" }}>{irrelevantCount} irrelevant</div>}
                                        </div>
                                    )
                                }
                            }
                            groupedRowData?.push(obj);
                        }
                    })
                    setRowData(_.sortBy(groupedRowData, "title"));
                } else {
                    const sortedData = data?.sort((a, b) => {
                        if (a?.user_display_name === b?.user_display_name) {
                            return a?.evaluator_display_name?.localeCompare(b?.evaluator_display_name);
                        }
                        return a?.user_display_name?.localeCompare(b?.user_display_name);
                    });
                    setRowData([{ id: "all", title: "", children: sortedData }]);
                }
                setFilterValue((prev) => ({ ...prev, isChange: false, additional_filters_counts: res?.body?.data?.table1?.[0] }));
                setSelectedRow([]);
                selectedRowRef.current = [];
                setLoader((prev) => ({ ...prev, grid: false }));
            }
        } catch (error) {
            setLoader((prev) => ({ ...prev, grid: false }));
            console.error("error", error)
        }
    }

    const handleSubmit = async () => {
        try {
            if (!formValue.users || formValue.users.length === 0) {
                showInfo("Info", "Please select at least one user.");
                return;
            } else if (!formValue.evaluator || formValue.evaluator.length === 0) {
                showInfo("Info", "Please select at least one evaluator.");
                return;
            }

            setLoader((prev) => ({ ...prev, btn: true }));
            let tvpArray = [];
            formValue?.users?.forEach(user => {
                formValue?.evaluator?.forEach(eva => {
                    tvpArray.push({
                        "user_code": user?.evaluator_user_code,
                        "evaluator_user_code": eva?.evaluator_user_code,
                        "is_manually": true,
                        "survey_id": filterValue?.survey?.survey_id
                    })
                })
            })
            const payload = {
                "user_evaluator_manual_mapping": tvpArray
            };
            const res = await services.getInvokeRemote("POST", Urls("SAVEUSEREVALUATORMANUALMAPPING"), payload)
            if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                showError("error", res?.body?.errorMessage);
                setLoader((prev) => ({ ...prev, btn: false }));
                return;
            } else {
                showSuccess("success", res.body.message);
                setShowPopup(false)
                setFormValue({})
                getEvaluatorList();
                setLoader((prev) => ({ ...prev, btn: false }));
            }
        } catch (error) {
            console.error("error", error);
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const saveAction = async (row, isApprove) => {
        try {
            if (!row && _.isEmpty(selectedRow)) {
                showInfo("Info", `Please select atleast one user to mark as ${isApprove ? "verified" : "irrelevant"}`);
                return;
            }
            const tvpArray = [];
            if (row) {
                tvpArray.push({
                    "user_code": row?.user_code || 0,
                    "evaluator_user_code": row?.evaluator_user_code || 0,
                    "is_discard": !isApprove,
                    "survey_id": filterValue?.survey?.survey_id || 0,
                    "is_verified": isApprove
                })
            } else {
                selectedRow?.forEach((rowdata) => {
                    tvpArray.push({
                        "user_code": rowdata?.user_code || 0,
                        "evaluator_user_code": rowdata?.evaluator_user_code || 0,
                        "is_discard": !isApprove,
                        "survey_id": filterValue?.survey?.survey_id || 0,
                        "is_verified": isApprove
                    })
                })
            }
            const payload = {
                user_evaluator_mapping_upsert: tvpArray
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSEREVALUATORMAPPING"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                // getEvaluatorList();
                if (row) {
                    setRowData(prevData => {
                        return prevData.map(parent => ({
                            ...parent,
                            children: parent.children.map(child =>
                                child.user_code === row.user_code && child?.evaluator_user_code === row?.evaluator_user_code
                                    ? {
                                        ...child,
                                        is_verified: isApprove,
                                        "is_discard": !isApprove,
                                        status: isApprove ? "verified" : "irrelevant"
                                    }
                                    : child
                            )
                        }));
                    });
                } else {
                    getEvaluatorList();
                }
                setSelectedRow([]);
                selectedRowRef.current = [];
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const getExcelDownload = async () => {
        if (_.isEmpty(rowData)) {
            showInfo("Info", "There is no data to download");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('E360_evaluator_mapping');
        const columnDef = _.filter(colDef, item => !item?.hide)
        const headers = filterValue?.group_by !== undefined ? [filterValue?.group_by ? "Employee Name" : "Evaluator Name", ..._.filter(_.pluck(columnDef, "label"), item => item && item !== "Action")] : _.filter(_.pluck(columnDef, "label"), item => item && item !== "Action")
        const fields = filterValue?.group_by !== undefined ? [filterValue?.group_by ? "user_display_name" : "evaluator_display_name", ..._.filter(_.pluck(columnDef, "key"), item => item && item !== "action" && item !== "checkbox")] : _.filter(_.pluck(columnDef, "key"), item => item && item !== "action" && item !== "checkbox");

        // add column headers
        const headerRow = worksheet.addRow(headers);
        headerRow.eachCell(cell => {
            cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE0E0E0' }
            };
        });
        worksheet.addRow(fields?.map((_, idx) => ""));

        const row = _.pluck(rowData, "children")?.flatMap(item => item);
        const groupedData = _.groupBy(row, filterValue?.group_by ? "user_display_name" : "evaluator_display_name");

        if (filterValue?.group_by !== undefined) {
            Object.values(groupedData).forEach((group) => {
                const startRow = worksheet.rowCount + 1;
                group.forEach((item, index) => {
                    const child = [];
                    fields?.forEach((fi, idx) => {
                        if (idx === 0) {
                            if (index === 0) {
                                child.push(item?.[fi] || "");
                            } else {
                                child.push("");
                            }
                        } else {
                            child.push(fi === "status" ? (item?.is_verified ? "verified" : (item?.is_discard ? "irrelevant" : "pending")) : item?.[fi] || "")
                        }
                    })
                    const childRow = worksheet.addRow(child);

                    childRow.outlineLevel = 1;
                });
                const endRow = worksheet.rowCount;

                // Merge grouped cell
                if (endRow > startRow) {
                    worksheet.mergeCells(startRow, 1, endRow, 1);
                }
            });
        } else {
            rowData?.[0]?.children.forEach((item, index) => {
                const dataArray = [];
                fields?.forEach((fi, idx) => {
                    dataArray.push(item?.[fi] || "");
                })
                worksheet.addRow(dataArray);
            });
        }


        // set dynamic widths for columns according to its content
        worksheet.columns.forEach((col) => {
            let maxLength = 10;
            col.eachCell({ includeEmpty: true }, (cell) => {
                const cellValue = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, cellValue.length);
            });
            col.width = maxLength + 2;
            col.alignment = { vertical: "top", horizontal: "left" };
        });

        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true };
        });

        worksheet.properties.outlineLevelRow = 1;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, `${filterValue?.survey?.survey_name?.split(" ")?.join("_")}_evaluator_mapping.xlsx`);
    };

    const getExcludeUsers = async () => {
        try {
            const payload = {
                survey_id: filterValue?.survey?.survey_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYEXCLUDEEVALUATORSLIST"), payload);
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.survey_exclude_evaluators_list;
                const savedData = (data || []).map(item => _.findWhere(options?.all_users, { user_code: item?.user_code })).filter(Boolean);
                if (!_.isEmpty(savedData)) {
                    setExclude((prev) => ({ ...prev, users: savedData, api_data: savedData }));
                    setOptions((prev) => ({ ...prev, filtered_exclude_users: exclude?.view ? [..._.sortBy(savedData, "user_display_name")] : [..._.filter(options?.all_users, item => !savedData?.includes(item))] }));
                } else {
                    setExclude((prev) => ({ ...prev, users: [], api_data: [] }));
                }
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const saveExcludeUsers = async () => {
        try {
            const payload = {
                "exclude_evaluators": _.pluck(exclude?.users, "user_code")?.toString() || "",
                "survey_id": filterValue?.survey?.survey_id
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSURVEYEXCLUDEEVALUATORSLIST"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                getExcludeUsers();
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "users" && _.some(formValue?.evaluator, eva => _.pluck(value, "evaluator_user_code")?.includes(eva?.evaluator_user_code))) {
            showInfo("info", 'This user is already selected as evaluator');
            return;
        } else if (name === "evaluator" && _.some(formValue?.users, user => _.pluck(value, "evaluator_user_code")?.includes(user?.evaluator_user_code))) {
            showInfo("info", 'This evaluator is already selected as user');
            return;
        }
        if (name === "users" && value?.length > 1 && formValue?.evaluator?.length > 1 || name === "evaluator" && value?.length > 1 && formValue?.users?.length > 1) {
            showInfo("info", 'You cannot select multiple Users and multiple Evaluators at the same time.');
            return;
        } else {
            setFormValue((prev) => ({ ...prev, [name]: value }));
        }
    }

    const optionTemplates = {
        survey: (option) => {
            return (
                <div className="d-flex gap-2 align-items-center justify-content-between evaluator-survey-opts">
                    <span>{option?.survey_name}</span>
                    <span className="rounded-pill border d-flex justify-content-center px-2" style={{ color: option?.survey_status === "active" ? "#026b02" : "", backgroundColor: option?.survey_status === "active" ? "#daedda" : "transparent" }}> {option?.survey_status} </span>
                </div>
            );
        },
        group_item: (option) => {
            return (
                <div className="d-flex gap-1 align-items-center justify-content-between" style={{ color: theme === "dark" ? "#A9ABAF" : "#505258" }}>
                    <FontAwesomeIcon icon={`fa-solid fa-${option?.value ? "user-group" : "user"}`} />
                    <span>{option?.label}</span>
                </div>
            );
        },
        group_value: (option, prop) => {
            return (
                option?.label ? <div className="d-flex gap-1 align-items-center" style={{ color: theme === "dark" ? "#A9ABAF" : "#505258" }}>
                    <FontAwesomeIcon icon={`fa-solid fa-${option?.value ? "user-group" : "user"}`} />
                    <span>{option?.label}</span>
                </div> : <div>{prop?.placeholder}</div>
            );
        },
        exclude_users_filter: (option) => {
            const allSelected = exclude?.users?.length > 0 && _.every(options?.all_users, item => _.pluck(exclude?.users, "user_code")?.includes(item?.user_code));
            const handleSelectAll = (checked) => {
                setExclude((prev) => ({ ...prev, users: checked ? [...options?.all_users] : [] }));
            };

            return (
                <div className="d-flex align-items-center gap-2 px-1">
                    <input type="checkbox" checked={allSelected} onChange={(e) => handleSelectAll(e?.target?.checked)} />
                    <div className='w95 border'>{option?.element}</div>
                </div>
            );
        },
        exclude_users: (option) => {
            return (
                <div className="d-flex align-items-center gap-3">
                    <input type='checkbox' checked={_.pluck(exclude?.users, "user_code")?.includes(option?.user_code)}
                        onChange={(e) => {
                            let dataArray = [...exclude?.users];
                            if (e.target?.checked) {
                                dataArray.push(option);
                            } else {
                                dataArray = _.filter(dataArray, item => item?.user_code !== option?.user_code);
                            }
                            setExclude((prev) => ({ ...prev, users: dataArray }));
                        }}
                    />
                    <div className="d-flex align-items-center gap-2">
                        <img className="rounded-circle" src={option?.image_url} width={30} height={30} alt="" onError={(e) => { e.target.onerror = null; e.target.src = "./assets/grey-user-icon.png"; }} />
                        <div>
                            <div className="fw-semibold">{option?.user_display_name}</div>
                            <div style={{ fontSize: "0.75rem", color: "grey" }}>{option?.employee_id}</div>
                        </div>
                    </div>
                </div>
            );
        },
    }


    return useMemo(() => ({
        loader, colDef, rowData, showPopup, setShowPopup, options, formValue, setFormValue, handleChange, handleSubmit, filterValue, setFilterValue, getEvaluatorList, getExcelDownload, tagRef, optionTemplates, exclude, setExclude, saveExcludeUsers, getExcludeUsers, showInfo, saveAction
    }), [loader, colDef, rowData, showPopup, setShowPopup, options, formValue, setFormValue, handleChange, handleSubmit, filterValue, setFilterValue, getEvaluatorList, getExcelDownload, tagRef, optionTemplates, exclude, setExclude, saveExcludeUsers, getExcludeUsers, showInfo, saveAction])
}